import { render, staticRenderFns } from "./LovePkList.vue?vue&type=template&id=270f558d&scoped=true"
import script from "./LovePkList.vue?vue&type=script&lang=js"
export * from "./LovePkList.vue?vue&type=script&lang=js"
import style0 from "./LovePkList.vue?vue&type=style&index=0&id=270f558d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f558d",
  null
  
)

export default component.exports